import React, { useLayoutEffect, useState } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compile } from 'path-to-regexp';
import { connect } from 'react-redux';
import { NavItem } from 'reactstrap';
import WizardMenuItem from '../../../../../containers/DefaultLayout/components/MainMenu/WizardMenuItem';
import { getOpportunityRoutes, qualificationPath } from '../InvestmentHandler/routes';
import { resetOpportunityWizard } from './actions';
import WizardStepper from './components/WizardStepper/WizardStepper';
import './OpportunityWizard.scss';
import ImgWithFallback from '../../../Portfolio/components/ImgWithFallback/ImgWithFallback';

const OpportunityWizard = (props) => {
  const {
    user, resetOpportunityWizard, isLoading, isLoadingOpportunity, tokenIcon, issuerLogo, data, opportunityId,
  } = props;
  const { pathname, search } = useLocation();
  const { accreditationFirst, isAccredited } = user || {};
  const routes = getOpportunityRoutes(isAccredited, accreditationFirst, data.allowSkipAccreditation);
  const match = matchPath(pathname, { path: '/opportunity/:id' });
  const [completeRoutes, setCompleteRoutes] = useState([]);
  const [allRoutesDisabled, setAllRoutesDisabled] = useState(false);
  const [rendered, setRendered] = useState(false);
  useLayoutEffect(() => {
    resetOpportunityWizard();
    setRendered(true);
    return () => {
      resetOpportunityWizard();
    };
  }, []);

  const createRoutePath = (route) => {
    const toPath = compile(route.path, { encode: encodeURIComponent });
    return match ? toPath(match.params) : route.path;
  };

  const opportunityRoutes = routes.map((oppRoute) => {
    const route = { ...oppRoute, path: createRoutePath(oppRoute), search };
    const qualification = qualificationPath.split('/').pop();
    const routePath = route.path.split('/').pop();
    return {
      ...route,
      ...oppRoute.path === qualificationPath ? { name: data.qualificationPageTitle, nameIsHtml: true } : {},
      isComplete: completeRoutes.includes(route.path),
      disabled: allRoutesDisabled || (routePath === qualification && isAccredited),
    };
  });

  return (
    <>
      {rendered && (
        <WizardStepper
          onRoutesDisable={setAllRoutesDisabled}
          onRoutesChange={setCompleteRoutes}
        />
      )}

      {isLoading || (isLoadingOpportunity && match.params.id !== opportunityId)
        ? (
          <div className="loader animated fadeIn pt-1 text-center">
            <div className="sk-spinner sk-spinner-pulse" />
          </div>
        )
        : (
          <>
            <NavItem className="logo-nav-securitize">
              <Link id="logo" to="/">
                <ImgWithFallback src={tokenIcon || issuerLogo} className="nav-img-avatar" />
              </Link>
            </NavItem>
            <div className="opportunity-wizard">
              {(opportunityRoutes.map((route) => (
                <li key={route.path} className={classNames('wizard-menu-item', 'animated', 'fadeIn')}>
                <WizardMenuItem {...route} /> {/* eslint-disable-line */}
                </li>
              )))}
            </div>
          </>
        )}
    </>
  );
};

OpportunityWizard.defaultProps = {
  user: {},
  resetOpportunityWizard: () => undefined,
  issuerLogo: '',
  tokenIcon: '',
  isLoading: true,
  isLoadingOpportunity: false,
  opportunityId: null,
  data: {},
};

OpportunityWizard.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  resetOpportunityWizard: PropTypes.func,
  issuerLogo: PropTypes.string,
  tokenIcon: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingOpportunity: PropTypes.bool,
  opportunityId: PropTypes.number,
  data: PropTypes.shape({ allowSkipAccreditation: PropTypes.bool, qualificationPageTitle: PropTypes.string }),
};

const mapStateToProps = (state) => {
  const { investment: { opportunityWizard, opportunity }, auth: { user }, issuerConfiguration: { config } } = state;
  return {
    data: opportunityWizard.data,
    user: user || {},
    tokenIcon: opportunity.data.tokenIcon,
    isLoading: opportunityWizard.isLoading,
    isLoadingOpportunity: opportunity.isLoading,
    opportunityId: opportunity.id,
    issuerLogo: config.favicon,
  };
};

export default connect(mapStateToProps, { resetOpportunityWizard })(OpportunityWizard);
